import { render, staticRenderFns } from "./FileDropZone.vue?vue&type=template&id=fb6da622&scoped=true"
import script from "./FileDropZone.vue?vue&type=script&lang=ts"
export * from "./FileDropZone.vue?vue&type=script&lang=ts"
import style0 from "./FileDropZone.vue?vue&type=style&index=0&id=fb6da622&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb6da622",
  null
  
)

export default component.exports